import ReactDOM from 'react-dom/client'

import { ClaimWidgetClasses, useCommonConnectStore } from 'components/WalletProvider/store'
import { WrapperWidget } from 'components/WrapperWidget'
import { formatDate } from 'utils/formatDate'
import { getTimeClaim } from 'utils/getTimeClaim'

import './style.scss'

import InitWidgets from './entrypoints/InitWidgets'

type InitProps = {
  claim: HTMLElement
  connect: HTMLElement
  customClassNames?: ClaimWidgetClasses
  progress: HTMLElement
}

const init = (props: InitProps) => {
  if (props.claim) props.claim.innerHTML = ''
  if (props.connect) props.connect.innerHTML = ''
  if (props.progress) props.progress.innerHTML = ''
  if (props.customClassNames) useCommonConnectStore.setState({ claimWidgetClasses: props.customClassNames })

  const detachedRoot = document.createElement('div')
  ReactDOM.createRoot(detachedRoot).render(
    <WrapperWidget>
      <InitWidgets elButtonWidget={props.connect} elClaimWidget={props.claim} elProgressWidget={props.progress} />
    </WrapperWidget>,
  )
}

export const LSDClaimLib = {
  formatDate,
  getTimeClaim,
  init,
  version: import.meta.env.VITE_BUILD_COMMIT,
} as const

export type LSDClaimLibTypes = typeof LSDClaimLib

if (typeof window !== 'undefined') {
  // @ts-expect-error
  window.LSDClaimLib = LSDClaimLib
}
